import { ISendNotificationGroupState } from './send-notification-group.model';
import { Action } from '@ngrx/store';
import * as Actions from '../send-notification-group/send-notification-group.actions';

export const sendNotificationGroupState: ISendNotificationGroupState = {
  isModalLoading: false,
  isModalLoaded: false,
  sendNotificationGroupDataLoading: false,
  sendNotificationGroupDataLoaded: false,
};

export function sendNotificationGroupReducer(
  state: ISendNotificationGroupState = sendNotificationGroupState,
  baseAction: Action,
): ISendNotificationGroupState {
  const action: Actions.SendNotificationGroupActions = baseAction as Actions.SendNotificationGroupActions;
  switch (action.type) {
    case Actions.GET_SEND_NOTIFICATION_MODAL_DATA:
      return {
        ...state,
        isModalLoading: true,
        isModalLoaded: false,
      };
    case Actions.GET_SEND_NOTIFICATION_MODAL_DATA_COMPLETED:
      return {
        ...state,
        isModalLoading: false,
        isModalLoaded: true,
      };
    case Actions.SEND_NOTIFICATION_GROUP_DATA:
      return {
        ...state,
        sendNotificationGroupDataLoading: true,
        sendNotificationGroupDataLoaded: false,
      };
    case Actions.SEND_NOTIFICATION_GROUP_DATA_COMPLETED:
      return {
        ...state,
        sendNotificationGroupDataLoading: false,
        sendNotificationGroupDataLoaded: true,
      };

    default:
      return state;
  }
}
